<template>
  <v-app>
    <v-navigation-drawer app clipped style="primary-bg" v-model="drawer">

      <div class="pb-8">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Overview</v-list-item-title>
            <v-list-item-subtitle>Manage shop</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group>
          <v-list-item :to="{name: 'overview'}">
            <v-list-item-action>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{overview.name || 'Overview'}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Operators</v-list-item-title>
            <v-list-item-subtitle>Manage operators</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group v-if="operators.length > 0">
          <draggable v-model="operators" class="" handle=".handle" ghost-class="operator__ghost">
            <v-list-item v-for="operator in operators"
                         :key="operator.id"
                         :to="{name: 'operator', params: {id: operator.id}}">
              <v-list-item-action>
                <v-icon>mdi-silverware</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <div class="d-flex" style="max-width: 100%;">
                  <v-icon v-if="operator.hidden" left>mdi-eye-off</v-icon>
                  <v-list-item-title>{{operator.name}}</v-list-item-title>
                </div>
              </v-list-item-content>
              <v-list-item-action class="handle" @mousedown.stop="">
                <v-icon>mdi-drag-horizontal-variant</v-icon>
              </v-list-item-action>
            </v-list-item>
          </draggable>
        </v-list-item-group>
        <v-list-item v-else>
          <v-list-item-title class="font-weight-light font-italic">No operators added</v-list-item-title>
        </v-list-item>

        <v-dialog v-model="newOperatorOpen" max-width="400px">
          <template #activator="{ on }">
            <v-list-item v-on="on" class="mt-2">
              <v-list-item-action>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Add operator</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <new-operator-form ref="newOperatorForm" @submit="addOperator" @abort="closeNewOperator"/>
        </v-dialog>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Content</v-list-item-title>
            <v-list-item-subtitle>Item groups &amp; side orders</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group>
          <v-list-item :to="{name: 'itemgroups'}">
            <v-list-item-action>
              <v-icon>mdi-folder</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Item groups</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'sideorders'}">
            <v-list-item-action>
              <v-icon>mdi-view-grid-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Side orders</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="operators.filter((op) => op.product_categories).length > 0"
            :to="{name: 'categories'}"
          >
            <v-list-item-action>
              <v-icon>mdi-shape</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Categories</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Reports</v-list-item-title>
            <v-list-item-subtitle>Reports &amp; statistics</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>


        <v-list-item-group>
          <v-list-item :to="{name: 'zreport'}">
            <v-list-item-action>
              <v-icon>mdi-alpha-z-box</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Z-Report</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'xreport'}">
            <v-list-item-action>
              <v-icon>mdi-alpha-x-box</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>X-Report</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'detailedreport'}">
            <v-list-item-action>
              <v-icon>mdi-file-document</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Detailed Report</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Orders</v-list-item-title>
            <v-list-item-subtitle>Browse orders</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group>
          <v-list-item :to="{name: 'payments'}">
            <v-list-item-action>
              <v-icon>mdi-cash-multiple</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Orders</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">Barview</v-list-item-title>
            <v-list-item-subtitle>Manage barview</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group>
          <v-list-item :to="{name: 'barviewaccess'}">
            <v-list-item-action>
              <v-icon>mdi-tablet-ipad</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Barview access</v-list-item-title>
            </v-list-item-content>
          </v-list-item>


          <v-list-item :to="{name: 'messages'}">
            <v-list-item-action>
              <v-icon>mdi-message-text</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Messages</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </div>

    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon color="white" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title v-if="$vuetify.breakpoint.name != 'xs'" class="app-header__title headline text-uppercase">
        <router-link class="app-header__title" to="/">
          <img
            class="app-header__logo"
            :src="require('./assets/ic_logotypewhite_1.svg')"
          >
          <span class="font-weight-light">ADMIN</span>
        </router-link>
      </v-toolbar-title>

      <v-spacer/>

      <base-items storeModule="overviews" v-slot="slotProps" @items="overview = $event[0] || {}">
        <template v-if="overview.name">
          <h2 class="white--text mx-2">{{overview.name}}</h2>
        </template>
        <div v-else></div>
      </base-items>

      <v-spacer/>

      <v-btn :disabled="!publishable" color="secondary" @click="publish">Publish</v-btn>

      <v-menu
        left
        bottom
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn icon dark v-on="on" class="ml-4">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="item in menu"
            :key="item.title"
            @click="item.action"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{item.title}}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-progress-linear
        :active="showToolbarLoader"
        :indeterminate="true"
        absolute
        bottom
        color="secondary"
      ></v-progress-linear>
    </v-app-bar>

    <v-main>
      <router-view/>
    </v-main>

    <v-overlay :value="isPublishing" class="justify-center">
      <div class="d-flex flex-column justify-center align-center">
        <h2>Publishing...</h2>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </div>
    </v-overlay>
  </v-app>
</template>

<script>
import NewOperatorForm from './components/NewOperatorForm.vue';
import {BaseItems} from 'dync-baseitem'
import draggable from 'vuedraggable'


export default {
  name: 'App',
  data () {
    return {
      overview: {},
      newOperatorOpen: false,
      drawer: null,
      menu: [
        {
          title: 'Audit log',
          icon: 'mdi-timeline-text-outline',
          action: () => {
            this.$router.push({name: 'auditlog'});
          }
        },
        {
          title: 'About',
          icon: 'mdi-information-outline',
          action: () => {
            this.$router.push({name: 'about'});
          }
        }
      ]
    }
  },
  computed: {
    showToolbarLoader () {
      return this.$store.getters.isLoadingFor('global')
    },
    operators: {
      get () {
        const operators = this.$store.getters['operators/items'].slice(0);
        operators.sort((o1, o2) => o1.order - o2.order);
        return operators;
      },
      set (operators) {
        const reorderedOperators = operators.map((o, i) => Object.assign({}, o, {order: i}));
        const reorderedOperatorsPayload = reorderedOperators.map(o => ({id: o.id, order: o.order}));

        this.$store.commit('startLoading', 'global');
        this.$store.commit('operators/replaceItems', reorderedOperators);
        this.$store.dispatch('operators/updateItems', reorderedOperatorsPayload).then(() => {
          this.$store.commit('endLoading', 'global');
        }).catch(() => {
          this.$store.commit('endLoading', 'global');
          this.$store.commit('operators/replaceItems', operators);
          this.$snackbar({message: 'An error happened while saving operator order.', theme: 'error'});
        });
      }
    },
    publishable () {
      return this.$store.getters['publications/hasChangesSincePublish'];
    },
    isPublishing () {
      return this.$store.getters.isLoadingFor('publications.create');
    },
    products () {
      return this.$store.getters['products/items'].slice(0);
    },
    itemgroups () {
      return this.$store.getters['itemgroups/items'].slice(0);
    },
    tabs () {
      return this.$store.getters['tabs/items'].slice(0);
    },
    messages () {
      return this.$store.getters['messages/items'].slice(0);
    }
  },
  watch: {
    products (newVal, oldVal) {
      this.checkUpdateDeleteditems(newVal, oldVal);
    },
    operators (newVal, oldVal) {
      this.checkUpdateDeleteditems(newVal, oldVal);
    },
    itemgroups (newVal, oldVal) {
      this.checkUpdateDeleteditems(newVal, oldVal);
    },
    tabs (newVal, oldVal) {
      this.checkUpdateDeleteditems(newVal, oldVal);
    },
    messages (newVal, oldVal) {
      this.checkUpdateDeleteditems(newVal, oldVal);
    }
  },
  methods: {
    checkUpdateDeleteditems (newVal, oldVal) {
      if (oldVal.length > newVal.length) {
        this.$store.dispatch('deleteditems/fetchItems');
      }
    },
    getNextOrderNumber() {
      var lastItem = this.operators[this.operators.length-1];
      if (lastItem && lastItem.order != undefined) {
        return lastItem.order + 1;
      } else {
        return 1;
      }
    },
    addOperator (operator) {
      operator.order = this.getNextOrderNumber();
      this.$store.dispatch('operators/createItem', operator).then((operator) => {
        this.closeNewOperator();
        this.$router.push({name: 'operator', params: {id: operator.id}});
      });
    },
    closeNewOperator () {
      this.newOperatorOpen = false;
      this.$refs.newOperatorForm.reset();
    },
    publish () {
      this.$store.dispatch('publications/publish').then(() => {
        this.$snackbar({message: 'Publish complete!', theme: 'success'});
      }).catch(() => {
        this.$snackbar({message: 'Something went wrong during publish', theme: 'error'});
      });
    }
  },
  mounted () {
    this.$store.dispatch('overviews/fetchItems');
    this.$store.dispatch('operators/fetchItems');
    this.$store.dispatch('products/fetchItems');
    this.$store.dispatch('publications/fetchItems');
    this.$store.dispatch('deleteditems/fetchItems');
  },
  components: {
    NewOperatorForm,
    BaseItems,
    draggable
  }
}
</script>

<style>
  .v-app-bar {
    background-color: var(--v-primary-base)!important;
  }
  .v-navigation-drawer {
    background-color: var(--v-secondary-base)!important;
  }

  .app-header__title {
    height: 100%;
    display: flex;
    align-items: center;
    color: #ffffff!important;
    text-decoration: none;
  }
  .app-header__logo {
    height: 75%;
  }

  .handle {
    cursor: grab;
  }
  .operator__ghost {
    background-color: var(--v-primary-base)!important;
  }
</style>
